'use strict';

var SafeLocalStorage = require('./SafeLocalStorage');

var Legacy = {
  loadDraftFromStorage() {
    var json = SafeLocalStorage.getItem('draft');
    if (json) {
      SafeLocalStorage.removeItem('draft');
      return JSON.parse(json);
    }
  }
};

module.exports = Legacy;


/** WEBPACK FOOTER **
 ** ./utils/Legacy.js
 **/